import React from "react";
import APPCONFIG from "../../constants/Config";
import moment from "moment";
import {ReceiptTaxSection, ReceiptSummaryRow, locationDefaultRateFromObject, cumulativeCashRefundedFromTaxJson} from "./ReceiptInvoiceLayout";
// Wrapper around ReactToPrint that works around its pattern of passing anonymous functions in the render method

// Layaway receipt — its math is layaway-scoped (no transaction-level discount/trade-in support today). The
// canonical "checkout totals" order of operations for transactions/receipts lives in
// `Checkout.recalculateTotals` (frontend, JSDoc) and `\Abstracts\Utilities::buildSectionFromLines` (backend);
// when layaway tax_json is unified with the transaction snapshot shape, mirror that order here too.
export default (data) => {

	//data parse
	let layawayInfo = data.data;
	let layawayItems = data.items;
	let layawayPayments = data.pData?.filter(item => item.amount !== "0.00");
	let layawayRefunds = [];
	if (Array.isArray(data.refundData?.items)) {
		layawayRefunds = data.refundData.items;
	} else if (Array.isArray(data.refundData)) {
		layawayRefunds = data.refundData;
	} else if (Array.isArray(data.refundData?.[0])) {
		layawayRefunds = data.refundData[0];
	}
	let customReceipt = data.rData.items[0];
	let location = layawayInfo.locations;
	const customerName = layawayInfo.customers ? layawayInfo.customers.name : layawayInfo.customer;
	const customerPhone = layawayInfo.customers ? layawayInfo.customers.phone : null;
	const customerEmail = layawayInfo.customers ? layawayInfo.customers.email : layawayInfo.receipt_email;
	const hasCustomerInfo = !!(customerName || customerPhone || customerEmail);

	let sub_total = 0;
	let singularItemDiscounts = 0;

	let items = layawayItems.entries.map((item, i) => {
		// console.log("item logging", item)
		//Fix for Firearms quantity
		let quantity = item.refund_quantity != null ? item.refund_quantity : (item.quantity !== null ? item.quantity : 1);

		// DB: price = selling/contract unit; cost = purchase cost (often 0) — prefer price, same as LayawayItems.js
		let price = parseFloat(item.price ?? item.cost ?? item.information?.price ?? 0) || 0;
		sub_total += price * quantity;

		//Getting singular item discounts from entries
		singularItemDiscounts += (parseFloat(item.discount_amount * quantity));

		return (
			<div>
				<br></br>
				<div key={'i' + i} style={{ borderBottom: "1px dashed #d6d6d6"}} id={"printItems"}>
					<div className={"row"}>
					     <span className={"col-6"}>
						     <span><strong>{item.name}</strong></span>
					     </span>
					<span className={"col-6 text-right"}>
							<span id={"printPrice"}>$ {price.toFixed(2)}</span>
						</span>
				</div>

					{item?.discount_amount != "0.00" ?
						<>
							<div className={"row"}>
								<span className={"col-6"}>
									<span><strong > Discount: </strong></span>
								</span>
								<span className={"col-6 text-right"}>
									<span>- $ {parseFloat(item.discount_amount).toFixed(2)}</span>
								</span>
							</div>
						</> : null
					}

					<div className={'row'}>
						<span className={'col-6'}>SKU: {item.sku}</span>
					</div>

					<div className={"row"}>
						<span className={"col-6"}>SN: {item.serial_number}</span>
						<span className={"col-6 text-right"}>

								<span id={"printRefunded"}>x{quantity}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									<strong>{"$ " + (parseFloat((price * quantity) - (item.discount_amount * quantity)).toFixed(2))}</strong>
								</span>
						</span>
					</div>
				</div>
			</div>
		)
	})

	let payments = layawayPayments.map((payment, i) => {
		let lastItem = i + 1 === layawayPayments.length;
		return (
			<div>
				<br></br>
				<div key={'p' + i} style={{borderBottom:  lastItem ? null : "1px dashed #d6d6d6"}} id={"printItems"}>
					<div className={"row"}>
					     <span className={"col-6"}>
						     <span><strong>{moment(payment.created).format('MM-DD-YYYY')}</strong></span>
					     </span>
						<span className={"col-6 text-right"}>
							<span id={"printPrice"}>$ {payment.amount}</span>
						</span>
					</div>
				</div>
			</div>
		)
	})

	let refunds = layawayRefunds.map((refund, i) => {
		let lastItem = i + 1 === layawayRefunds.length;
		const refundDate = refund.created ?? refund.Created;
		const refundAmount = parseFloat(refund.amount ?? refund.Amount ?? 0) || 0;
		return (
			<div key={'r' + i}>
				<br></br>
				<div style={{borderBottom: lastItem ? null : "1px dashed #d6d6d6"}} id={"printItems"}>
					<div className={"row"}>
						<span className={"col-6"}>
							<span><strong>{moment(refundDate).format('MM-DD-YYYY')}</strong></span>
						</span>
						<span className={"col-6 text-right"}>
							<span id={"printPrice"} style={{color: "red"}}>$ {refundAmount.toFixed(2)}</span>
						</span>
					</div>
				</div>
			</div>
		)
	})

	let refundTotal = parseFloat(layawayInfo.amount_refunded) || 0;
	const metaRefund = cumulativeCashRefundedFromTaxJson(layawayInfo.tax_json);
	if (metaRefund != null && metaRefund >= 0.01) {
		refundTotal = metaRefund;
	}
	if (refundTotal < 0.01 && layawayRefunds.length > 0) {
		refundTotal = layawayRefunds.reduce((sum, refund) => {
			return sum + (parseFloat(refund.amount ?? refund.Amount ?? 0) || 0);
		}, 0);
	}

	let layawayCreatedDate = moment(layawayInfo.created).format('MM-DD-YYYY');

	//custom for stone inc (they're in central so its not that bad rn...)
	let layawayCreatedTime = moment(layawayInfo.created).format('HH:mm:ss');

	const layawayTax = parseFloat(layawayInfo.tax_amount) || 0;
	const layawayAmount = parseFloat(layawayInfo.amount) || 0;
	const ccFeeAmount = parseFloat(layawayInfo.cc_fees || 0);
	const taxableMerchApprox = layawayAmount - layawayTax - ccFeeAmount;
	const locationDefaultRate = locationDefaultRateFromObject(location);

	return (
		<>
			<div>
				{location ?
					<div className={"receiptHeader"} style={{marginTop: "1rem"}}>
						<span style={{textAlign: "center", fontSize: '1rem'}}>
							{customReceipt.logo &&
								<div>
									<img
										id="logo"
										src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/accounts/customizations/image'}
										alt={""}
										style={{marginBottom: "0.8rem", height:"115px"}}
									/>
								</div>
							}
							<div>
								{location.name? <div><b>{location.name}</b></div> : null}
								{location.store_number ? <div>{location.store_number}</div> : null}
								{location.phone ? <div>{location.phone}</div> : null}
								{location.email ? <div>{location.email}</div> : null}
								{location.street_1 ? <div>{location.street_1}</div> : null}
								{location.street_1 ? <div>{location.city} {location.state} {location.zip}</div> : null}
								{layawayCreatedDate} {(data.account === 183 || data.account === 10) ? layawayCreatedTime : ""}
								<br/>
								<br/>
							</div>
						</span>
					</div> : null}

				<div style={{fontSize: '20px', borderBottom: "1px solid #d6d6d6", marginTop:"1rem", paddingBottom: "10px"}}>
					<b>Layaway #{data.data.pkey}</b>
				</div>
				<div>
					{items}
				</div>
				<div className={"row"}  style={{color: "rgba(0, 0, 0, 0.5)", paddingTop: "10px"}}>
					<div className={"col"} id={"poInfo"}>
						{/*Conditionally show po order information*/}
						{layawayInfo.po_number ?
							<div>
								<span>PO Number</span><span style={{float: "right"}}>{layawayInfo.po_number}</span><br/>
							</div> : null
						}
					</div>
				</div>

				<div className="invoice-sum text-right" >
					<ul className="list-unstyled">
						<ReceiptSummaryRow label="Sub Total:" amount={`$ ${sub_total.toFixed(2)}`} />
						{singularItemDiscounts ? (
							<ReceiptSummaryRow
								label="Singular Discounts:"
								amount={`- $ ${parseFloat(singularItemDiscounts).toFixed(2)}`}
							/>
						) : null}
						<ReceiptTaxSection
							taxJson={layawayInfo.tax_json}
							taxAmount={layawayTax}
							taxableMerchandiseApprox={taxableMerchApprox}
							defaultRatePercent={locationDefaultRate}
							showTaxBreakdown={data.props?.show_tax_breakdown}
						/>
						{ccFeeAmount > 0 && (
							<ReceiptSummaryRow label="CC Fee:" amount={`$ ${ccFeeAmount.toFixed(2)}`} />
						)}
						<ReceiptSummaryRow label="Total:" amount={`$ ${layawayInfo.amount}`} strong />
						<ReceiptSummaryRow label="Remaining:" amount={`$ ${layawayInfo.remaining}`} strong />
						{refundTotal >= 0.01 ? (
							<li id="refunded" style={{color: "red"}}>
								<strong>Total refunded: - $ {refundTotal.toFixed(2)}</strong>
							</li>
						) : null}
					</ul>
				</div>

				{/*payments*/}
				<div>
					{payments && payments.length > 0 && <hr />}
					<div>
						{payments && payments.length > 0 && (
							<>
								<div style={{textAlign: "center"}}>
									<div style={{fontSize: "1.2rem"}}><b>Payments Made</b></div>
									<br/>
								</div>
								{payments}
							</>
						)}
					</div>
				</div>

				{/*refunds*/}
				<div>
					{refunds && refunds.length > 0 && <hr />}
					<div>
						{refunds && refunds.length > 0 && (
							<>
								<div style={{textAlign: "center"}}>
									<div style={{fontSize: "1.2rem"}}><b>Refunds Made</b></div>
									<br/>
								</div>
								{refunds}
							</>
						)}
					</div>
				</div>

				{/*Don't show line if there is no transaction info*/}
				{!customReceipt.message && !customReceipt.warranty && !customReceipt.return_policy ? null : <hr></hr>}
				<div id="customMessageContainer">
					<div style={{textAlign: "center"}}>
						<h4 id="customMessage">
							{customReceipt.message ?? ""}
						</h4>
						{customReceipt.warranty &&
							<div style={{textAlign: "center"}}>
								<span><b>Warranty Information</b></span>
								<div>
									{customReceipt.warranty}
								</div>
								<br/>
								<br/>
							</div>
						}
						{customReceipt.return_policy &&
							<div style={{textAlign: "center"}}>
								<span><b>Returns Information</b></span>
								<div>
									{customReceipt.return_policy}
								</div>
								<br/>
								<br/>
							</div>
						}
					</div>
				</div>

				{/*Section for Other Transaction information regarding the client*/}
				{data.props?.show_customer_info ||
				layawayInfo.description ||
				layawayInfo.layaway_notes ||
				layawayInfo.customer_notes ?
					<div>
						<hr />
						{data.props?.show_customer_info ? (
							<div style={{textAlign: "center"}}>
								<div style={{fontSize: "1.2rem"}}><b>Customer Information</b></div>
								{hasCustomerInfo ? (
									<>
										{customerName ? <div>{customerName}</div> : null}
										{customerPhone ? <div>{customerPhone}</div> : null}
										{customerEmail ? <div>{customerEmail}</div> : null}
									</>
								) : (
									<div><i>There is no customer info to display.</i></div>
								)}
								<br/>
							</div>
						) : layawayInfo.description || layawayInfo.layaway_notes || layawayInfo.customer_notes ? (
							<div style={{textAlign: "center"}}>
								<div style={{fontSize: "1.2rem"}}><b>Additional Information</b></div>
								<br/>
							</div>
						) : null}
						{layawayInfo.description ?
							<div style={{textAlign: "center"}}>
								<span><b>Description</b></span>
								<div>
									{layawayInfo.description}
								</div>
								<br/>
							</div> : null}

						{layawayInfo.layaway_notes ?
							<div style={{textAlign: "center"}}>
								<span><b>Layaway Notes</b></span>
								<div>
									{layawayInfo.layaway_notes}
								</div>
								<br/>
							</div> : null }
					</div>
				: null}
			</div>
		</>
	)
}
